export const validation = {
  titleMaxChar: 60,
  paragraphMaxChar: 700,
}
